export const countries: Record<
  string,
  Record<'countryCode' | 'countryName', string | string>
> = {
  AU: { countryCode: '+61', countryName: 'Australia' },
  NZ: { countryCode: '+64', countryName: 'New Zealand' },
  GB: { countryCode: '+44', countryName: 'United Kingdom' },
};

export const allowedUserCountries = Object.keys(countries);

export const mfaTokenPrefix = 'IdentityService';
